export const UPDATE_GROUPS = "UPDATE_GROUPS";

export const updateGroups = (value) => ({
  type: UPDATE_GROUPS,
  value,
});
